// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"0bc2f7e3","238":"30c34cad","239":"f83e3eab","361":"b043ec84","455":"a244bf8d","641":"c0a1606d","857":"77ade747","977":"7e011fe5"}[chunkId] + ".chunk.js";
};